import { appConfig } from 'config/customization';

const content = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  backgroundColor: appConfig.colors.inactiveSidebarColor,
  paddingBottom: 10
};

export default {
  arrowIcon: {
    justifyContent: 'flex-end',
    marginLeft: 'auto'
  },
  activeHeader: {
    opacity: 1,
    display: 'flex',
    flex: 1
  },
  header: {
    opacity: 0.5,
    display: 'flex',
    flex: 1
  },
  activeContent: {
    ...content,
    backgroundColor: appConfig.colors.activeSidebarColor
  },
  inactiveContent: {
    ...content,
    backgroundColor: appConfig.colors.inactiveSidebarColor
  }
};
